import API from "../../../utils/helpers/API.helpers";

const MahasiswaSidangService = {
  async getMKSpesialMahasiswa() {
    return await API.get({ endpoint: "/mahasiswa/get-riwayat-sidang" });
  },
  async getJadwalSidangByMKSpesialId(mKSpesialId) {
    return await API.get({
      endpoint: `/mahasiswa/get-jadwal-sidang?mk_spesial=${mKSpesialId}`,
    });
  },
  async getRiwayatRevisiByMKSpesialID(mKSpesialId) {
    return await API.get({
      endpoint: `/mahasiswa/get-riwayat-revisi-dosen?mk_spesial=${mKSpesialId}`,
    });
  },
};

export default MahasiswaSidangService;
